export const dealsRoutes = {
  path: '/deals',
  children: [
    {
      name: 'newDeal',
      path: 'new',
      component: () => import('pages/Deals/NewDeal/index.vue'),
      meta: {
        title: 'New Deals',
      },
    },
  ],
}
